import React from 'react';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import api from '../../api/axiosInstance';
ChartJS.register(BarElement, CategoryScale, LinearScale);

const BarChart = ({ data }) => {debugger;
    const chartData = {
        labels: data.map(entry => entry.date), // Get the month names for the x-axis
        datasets: [
            {
                label: 'Forms Submitted (Past 7 Months)',
                backgroundColor: 'rgba(60,141,188,0.9)',
                data: data.map(entry => entry.count), // Get the counts for the y-axis
            },
        ],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    display: false,
                },
            },
            y: {
                grid: {
                    display: false,
                },
            },
        },
    };

    return (
        <div className="card card-success">
            <div className="card-header">
                <h3 className="card-title">Forms Submitted in last 7 Months:</h3>
                <div className="card-tools">
                    <button type="button" className="btn btn-tool" data-card-widget="collapse">
                        <i className="fas fa-minus"></i>
                    </button>
                    <button type="button" className="btn btn-tool" data-card-widget="remove">
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            </div>
            <div className="card-body">
                <div className="chart" style={{ position: 'relative', height: '250px' }}>
                    <Bar data={chartData} options={options} />
                </div>
            </div>
        </div>
    );
};

export default BarChart;
